import type { PaymentTransaction } from "../../../domain/entities/PaymentTransaction";
import type { OrderId } from "../../../domain/value-objects/OrderId";
import type { PaymentTransactionQueryPort } from "../../../application/ports/PaymentTransactionQueryPort";
import type { PaymentTransactionHttp } from "../../mappers/paymentTransactionMapper";
import { mapPaymentTransaction } from "../../mappers/paymentTransactionMapper";

interface PaymentTransactionsHttpAdapterConfig {
  baseUrl: string;
  authorizationToken: string;
}

interface PageTransactionHttp {
  items: PaymentTransactionHttp[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
}

const TRANSACTIONS_PATH = "transactions";

export class PaymentTransactionsHttpAdapter implements PaymentTransactionQueryPort {
  constructor(private readonly config: PaymentTransactionsHttpAdapterConfig) {}

  async findLatestByReferenceCode(referenceCode: OrderId): Promise<PaymentTransaction | null> {
    const url = this.composeUrl(TRANSACTIONS_PATH, {
      reference_code: referenceCode,
      limit: "1",
      page: "1",
    });

    const response = await fetch(url, {
      headers: this.buildHeaders(),
    });

    if (!response.ok) {
      throw new Error("No fue posible obtener el estado del pago asociado a la orden");
    }

    const payload = (await response.json()) as PageTransactionHttp;
    const [transaction] = payload.items ?? [];

    if (!transaction) {
      return null;
    }

    return mapPaymentTransaction(transaction);
  }

  private composeUrl(path: string, params: Record<string, string>): string {
    const normalizedBase = this.config.baseUrl.endsWith("/") ? this.config.baseUrl : `${this.config.baseUrl}/`;
    const url = new URL(path, normalizedBase);

    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });

    return url.toString();
  }

  private buildHeaders(): HeadersInit {
    return {
      Accept: "application/json",
      Authorization: `${this.config.authorizationToken}`,
    };
  }
}
